export const pdfReportFunctionAddress = 'https://msa-report-api.mapshare.vic.gov.au/report'